import { useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'motion/react';
import { Icons } from "../../../icons/Icons";
import Branding from './Branding';
import BuilderService from '../../../services/BuilderService';
import { Menu } from 'lucide-react';
import { useUserDetails } from '../../../../redux/hooks/UserDetails';
import { useTheme, useUpdateTheme, } from '../../../../redux/hooks/useTheme';
import useOnClickOutside from '../../../../redux/hooks/useOnClickOutside';
import { ChevronDown } from "lucide-react";
import ThemeToggle from './ThemeToggle';
import { useUpdateJson } from '../../../../redux/hooks/useJson';
import Logo from './Logo';
import ReCAPTCHAComponent from '../../../utils/ReCAPTCHA';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../../components/ui/dropdown-menu"
import PlanPopup from '../../../utils/HelperComponents/PlanPopup';
interface HeaderProps {
  isDifferentStyle?: boolean; // For different styling
  noPadding?: boolean; // To control padding
  addBottomBorder?: boolean;
  paddingTop?: boolean; // To control bottom border
  hideBorder?: boolean;
  paddingX?: boolean;
  paddingY?: boolean
  className?: string;           // Custom class names from parent
  style?: React.CSSProperties;  // Inline styles from parent
}
interface ScrollConfig {
  id: string;
  callback?: () => void;
}


export default function Header({ isDifferentStyle, noPadding, addBottomBorder, paddingTop, hideBorder, paddingX, paddingY, className = '',
  style = {}, }: HeaderProps) {
  const { theme} = useTheme();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { toggleTheme } = useUpdateTheme();
  const { userDetail } = useUserDetails();
  const {updateProperty}=useUpdateJson();
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const isDarkMode = theme.background === "rgb(51, 51, 51)";
  const [isBrandingOpen, setIsBrandingOpen] = useState(false);
  const prevCustomBrandRef = useRef<{ custombrand: any; enabled: any } | undefined>(undefined);
  const [isToggled, setIsToggled] = useState(false);
  const navigate= useNavigate();
  const location = useLocation();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const builderService = new BuilderService();
  const [showPlanPopup, setShowPlanPopup] = useState(false);
const [planPopupMessage, setPlanPopupMessage] = useState('');
console.log("theme11:",theme)

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const handleLogout = async () => {
    try {
      await builderService.logoutUser();
      window.location.href = '/';
      localStorage.removeItem('savedPrompt')
    } catch (error) {
      console.log('Logout failed', error);
    }
  };

  const toggleSwitch = () => {
    setIsToggled(!isToggled);
  };


  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState); // Toggle the menu state
  };

  // Helper function to get first non-empty character from a string
  const getFirstNonEmptyChar = (str: string): string => {
    if (!str) return '?';
    
    // Remove leading/trailing whitespace and find first non-empty character
    const trimmedStr = str.trim();
    for (let i = 0; i < trimmedStr.length; i++) {
      if (trimmedStr[i] && trimmedStr[i] !== ' ') {
        return trimmedStr[i].toUpperCase();
      }
    }
    return '?';
  };

  useOnClickOutside(
    dropdownRef,
    () => setDropdownVisible(false),
    buttonRef
  );
  const scrollConfigs = {
    home:{
      id:'scrollToTextArea'
    },
    features: { 
      id: 'scrollToFeatures'
    },
    premades: {
      id: 'scrollToPremades',
      callback: () =>{
        localStorage.setItem('forcePremadesTab', 'true');
        // updateProperty('selectedTab', 'Premades');
        navigate('/'); 
     }
    },
    pricing: {
      id: 'scrollToPricing'
    }
  };

  const scrollToSection = (config: ScrollConfig) => (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/');

    setTimeout(() => {
      const element = document.getElementById(config.id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        if (config.id === 'scrollToFeatures') {
          window.history.replaceState(null, '', window.location.pathname);
        }
        config.callback?.();
      }
    }, 500);
  };


  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
    <ReCAPTCHAComponent/>
      <motion.header
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className={`
          sticky top-0 p-4 z-50
          text-white tablet-padding 
          p-0
          sm:px-[22px] sm:py-[30px] 
          md:px-[50px] md:py-[30px] 
          ${noPadding ? 'sm:px-0 md:px-0' : ''} 
          ${isDifferentStyle ? 'prompt-gallery' : ''} 
          ${paddingTop ? 'pt-[20px]' : ''} 
          ${paddingX ? '50px' : ''}
          ${paddingY ? '30px' : ''}
        `}
      >
        <div
          style={{
            background: theme.hedaerBackground,
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)", // For Safari support
            borderRadius: '20px',
            maxWidth:'1240px',
            position: "relative",
            ...(userDetail && { zIndex: '2' })
          }}
          className={`header-container header-sdw mx-auto flex justify-between items-center p-[16px] h-auto sm:h-[71px] sm:pl-[16px] sm:p-[12px]`}


        >
          <motion.div
            className="flex items-center w-[132px] sm:w-auto logo-mob"
          // whileHover={{ scale: 1.05 }}
          // whileTap={{ scale: 0.95 }}
          >
            <Link to="/">
              {/* <img
                src={theme.heroLogo} // Use src instead of background
                className="h-10 mr-2 md:p-0"
                alt="Advance To Builder"
              /> */}
              <Logo/>
            </Link>
          </motion.div>

          <motion.div>
          <nav style={{color:theme.headerLinks}} className="flex naigation-links gap-[40px] text-[16px] font-medium ">
              <Link to="/#scrollToTextArea" className="link-hover font-inter p-[10px]" onClick={scrollToSection(scrollConfigs.home)} >Home</Link>
              <Link to="/#scrollToFeatures" className="link-hover font-inter p-[10px]"
                onClick={scrollToSection(scrollConfigs.features)}
              >Features</Link>
              {/* <div className="relative link-hover p-[10px]">
                <button
                style={{zIndex:'1'}}
                  className="flex items-center gap-1  "
                  onClick={() => setIsOpen(!isOpen)}
                >
                  Resources <ChevronDown size={16} />
                </button>
                {isOpen && (
                  <div style={{width:'190px', zIndex:'1'}} className="absolute mt-2 bg-white shadow-lg rounded-[10px] p-[12px]">
                      <Link  to="#" className="flex items-center space-x-3 hover:bg-gray-100 rounded-lg p-2 cursor-pointer">
                        <span> 
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.75008 16.5833V3.41666C8.75008 2.16666 8.21675 1.66666 6.89175 1.66666H3.52508C2.20008 1.66666 1.66675 2.16666 1.66675 3.41666V16.5833C1.66675 17.8333 2.20008 18.3333 3.52508 18.3333H6.89175C8.21675 18.3333 8.75008 17.8333 8.75008 16.5833Z" stroke="url(#paint0_linear_108_1972)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M18.3333 7.1V3.31666C18.3333 2.14166 17.8 1.66666 16.475 1.66666H13.1083C11.7833 1.66666 11.25 2.14166 11.25 3.31666V7.09166C11.25 8.275 11.7833 8.74166 13.1083 8.74166H16.475C17.8 8.75 18.3333 8.275 18.3333 7.1Z" stroke="url(#paint1_linear_108_1972)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M18.3333 16.475V13.1083C18.3333 11.7833 17.8 11.25 16.475 11.25H13.1083C11.7833 11.25 11.25 11.7833 11.25 13.1083V16.475C11.25 17.8 11.7833 18.3333 13.1083 18.3333H16.475C17.8 18.3333 18.3333 17.8 18.3333 16.475Z" stroke="url(#paint2_linear_108_1972)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                              <defs>
                              <linearGradient id="paint0_linear_108_1972" x1="1.66675" y1="1.66666" x2="19.0001" y2="19" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#FF3AB6"/>
                              <stop offset="1" stopColor="#FB5F65"/>
                              </linearGradient>
                              <linearGradient id="paint1_linear_108_1972" x1="1.5" y1="1.49999" x2="18.5" y2="19" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#FF3AB6"/>
                              <stop offset="1" stopColor="#FB5F65"/>
                              </linearGradient>
                              <linearGradient id="paint2_linear_108_1972" x1="2" y1="1.5" x2="18.3333" y2="18.3333" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#FF3AB6"/>
                              <stop offset="1" stopColor="#FB5F65"/>
                              </linearGradient>
                              </defs>
                              </svg>
                        </span>
                        <span className="text-[#222222] text-[16px] font-medium">Templates</span>
                      </Link>
                      <Link to="/prompt-gallery" className="flex items-center space-x-3 hover:bg-gray-100 rounded-lg p-2 cursor-pointer mt-2">
                          <span>      
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M17.5 5.83334V14.1667C17.5 16.6667 16.25 18.3333 13.3333 18.3333H6.66667C3.75 18.3333 2.5 16.6667 2.5 14.1667V5.83334C2.5 3.33334 3.75 1.66667 6.66667 1.66667H13.3333C16.25 1.66667 17.5 3.33334 17.5 5.83334Z" stroke="url(#paint0_linear_108_1942)" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M12.0833 3.75V5.41667C12.0833 6.33333 12.8333 7.08333 13.7499 7.08333H15.4166" stroke="url(#paint1_linear_108_1942)" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M6.66675 10.8333H10.0001" stroke="url(#paint2_linear_108_1942)" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M6.66675 14.1667H13.3334" stroke="url(#paint3_linear_108_1942)" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                              <defs>
                              <linearGradient id="paint0_linear_108_1942" x1="2.5" y1="1.66667" x2="17.5" y2="18.3333" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#FF3AB6"/>
                              <stop offset="1" stopColor="#FB5F65"/>
                              </linearGradient>
                              <linearGradient id="paint1_linear_108_1942" x1="2.7777" y1="2.22222" x2="16.4332" y2="20.3223" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#FF3AB6"/>
                              <stop offset="1" stopColor="#FB5F65"/>
                              </linearGradient>
                              <linearGradient id="paint2_linear_108_1942" x1="2.77786" y1="3.08333" x2="16.0569" y2="19.4773" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#FF3AB6"/>
                              <stop offset="1" stopColor="#FB5F65"/>
                              </linearGradient>
                              <linearGradient id="paint3_linear_108_1942" x1="3.88897" y1="3.41667" x2="15.0584" y2="19.0647" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#FF3AB6"/>
                              <stop offset="1" stopColor="#FB5F65"/>
                              </linearGradient>
                              </defs>
                              </svg>
                          </span> 
                          <span className="text-[#222222] text-[16px] font-medium">Prompt Gallery</span>
                     </Link>
                </div>
                )}
              </div> */}
              <Link to="/#scrollToPremades" className="link-hover font-inter p-[10px]"
                onClick={scrollToSection(scrollConfigs.premades)}

              >Tools</Link>

              {/* <DropdownMenu>
                <DropdownMenuTrigger >
                  <span className='flex items-center'>
                    AI Agent
                    <ChevronDown className='w-5 h-5 ml-2' />
                  </span>
                </DropdownMenuTrigger>
                <DropdownMenuContent className='border-none py-3'>
                  <DropdownMenuItem  style={{all:'unset'}}>
                    <Link to="/ai-agent/ai-img-generator" className="link-hover font-inter p-[10px] flex items-center text-sm">AI Image Generator</Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem style={{all:'unset'}}>
                    <Link to="/ai-agent/ai-img-editor" className="link-hover font-inter p-[10px] flex items-center text-sm">AI Image Editor</Link>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu> */}
              <Link to="/prompt-gallery" className="link-hover font-inter p-[10px]">Prompt Gallery</Link>

              {!userDetail && <Link to="/#scrollToPricing" onClick={scrollToSection(scrollConfigs.pricing)} className="link-hover font-inter p-[10px]"   >Pricing</Link> }
            </nav>
          </motion.div>


          {/*<div className="relative md:flex space-x-8  md:pt-0">
            <button
              style={{ color: theme.Darkone }}
              className="block md:hidden"
              onClick={toggleMenu}
            >
              <Menu />
            </button>
            {isMenuOpen && (

              <div style={{ backgroundColor: theme.heroSectionInputBg }} className={`block md:hidden mobmenu`}>
                <a style={{ color: theme.headerButtons }} className="block md:hidden" href="#" >Home</a>
                 <a style={{ color: theme.headerButtons }} className="block md:hidden" href="#">Tutorial</a>
                <a style={{ color: theme.headerButtons }} href="#">Features</a>
                <a style={{ color: theme.headerButtons }} href="#">About Us</a> */}
          {/* <a
                  style={{
                    color: theme.hedaerLinksMain,
                  }}
                  className="flex items-center sm:justify-center justify-start"
                  href="#"
                >
                  Templates
                  <span
                    style={{
                      marginLeft: '15px',
                      color: theme.hedaerLinksMain,
                      width: '18px',
                      height: '18px',
                    }}
                    className="hidden md:inline"
                  >
                    <svg
                      width="19"
                      height="20"
                      viewBox="0 0 19 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_3308_6224)">
                        <g clip-path="url(#clip1_3308_6224)">
                          <path
                            d="M4.96777 7.69995L8.76077 11.493C8.9483 11.6804 9.20261 11.7857 9.46777 11.7857C9.73294 11.7857 9.98725 11.6804 10.1748 11.493L13.9678 7.69995"
                            stroke="#F8F8F8"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_3308_6224">
                          <rect
                            width="18"
                            height="19"
                            fill="white"
                            transform="translate(0.467773 0.5)"
                          />
                        </clipPath>
                        <clipPath id="clip1_3308_6224">
                          <rect
                            width="18"
                            height="18"
                            fill="white"
                            transform="translate(0.467773 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </a> 

              </div>
            )}
          </div>*/}
          <div style={{justifyContent:'center', alignItems:'center'}} className="flex links-ap gap-[10px] pt-0">

            <ThemeToggle />


            <motion.button style={{color:theme.headerLinks,display: userDetail ? 'none' : 'visible',}}>
              {/* <a href="#" className="p-[10px] text-[16px] py-[9px] font-medium login-mob">Log In</a> */}
            </motion.button>

            <div style={{ alignItems: 'center' }} className="relative inline-block text-left ml-[10px] flex justify-center sm:ml-[5px]">
              {userDetail ? (
                <motion.button
                  className="flex items-center justify-center font-semibold "
                  style={{
                    background: "linear-gradient(298.16deg, rgba(251, 95, 101, 0.1) 10.43%, rgba(255, 58, 182, 0.1) 88.71%)",
                    color: "#FFFFFF",
                    fontSize: "16px",
                    width: userDetail ? '47px' : 'auto',
                    height: '47px',
                    borderRadius: "21.5px",
                    padding: '0 16px',
                  }}
                  ref={buttonRef}
                  onClick={() => setDropdownVisible(!isDropdownVisible)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <h2></h2>

                  {userDetail && userDetail?.ogUserId ? (
                    <span className='gradient-text ' style={{ fontSize: '20px', fontWeight: 500,  }}>
                      {getFirstNonEmptyChar(userDetail.ogCompanyName)}
                    </span>
                  ) : (
                    <span className='gradient-text ' style={{ fontSize: '20px', fontWeight: 500 }}>
                      {getFirstNonEmptyChar(userDetail.name)}
                    </span>
                  )}
                </motion.button>
              ) : (
                // New login button UI
                <>
                  {/* <motion.button
                  className="flex items-center justify-center login"
                  style={{
                    width: '80px',
                    height: '36px',
                    fontSize: '14px',
                    fontWeight: '500',
                    lineHeight: '20px',
                  }}
                  onClick={() => (navigate('/login'))}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span>Login</span>
                </motion.button> */}
                  <motion.button
                    className="flex login-alt signup-mob items-center justify-center login px-[26px] py-[12px]"
                    style={{
                      fontSize: '14px',
                      fontWeight: '500',
                      lineHeight: '20px',
                      // radius:'12px'
                    }}
                    onClick={() => {
                      const currentDomain = window.location.hostname;
                      console.log("currentDomain:", currentDomain)
                      if (currentDomain === 'autoolic.outgrow.co' || currentDomain ==='ai-tool-builder.web.app') {
                        window.location.href = process.env.REACT_APP_REDIRECT_URL || '/';
                      } else {
                        navigate('/login');
                      }
                    }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <span style={{fontSize:'16px', fontWeight:500}} className='font-sora login-mob'>Login</span>
                  </motion.button>
                </>
              )}
              {/* <AnimatePresence>
                {isDropdownVisible && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.2 }}
                    className="absolute right-0 mt-2 w-auto rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 z-50 overflow-hidden"
                    style={{ backgroundColor: theme.background, position:'absolute', top:'-23px'}}
                    onMouseLeave={toggleDropdown}
                  >
                    <div className="pt-2 ">
                      <div className="px-4 border-b-[1px]" style={{ borderColor: theme.border }}>
                        <p className="text-[14px] font-medium flex items-center pb-3" style={{ color: theme.color }}>
                          <span
                            style={{
                              backgroundImage: 'url("https://dlvkyia8i4zmz.cloudfront.net/h9b3CvGGTpiFiaKnJE0Q_profile.svg")',
                              backgroundSize: 'contain',
                              backgroundRepeat: 'no-repeat',
                              display: 'inline-block',
                              width: '24px',
                              height: '24px',
                              marginRight: '10px'
                            }}
                          />
                          {userDetail && userDetail.name}
                        </p>
                        <p className="text-[14px] mb-1 font-medium flex items-center  pb-3" style={{ color: theme.color }}>
                          <span
                            style={{
                              backgroundImage: 'url("https://dlvkyia8i4zmz.cloudfront.net/BNaSC3I6RsOPSHIrSZfb_mail.svg")',
                              backgroundSize: 'contain',
                              backgroundRepeat: 'no-repeat',
                              display: 'inline-block',
                              width: '24px',
                              height: '24px',
                              marginRight: '10px',
                              paddingRight: '5px',
                            }}
                          />
                          <span className="">{userDetail && userDetail.email}</span>
                        </p>
                      </div>
                    
                      <motion.button
                        onClick={toggleTheme}
                        className="w-full text-left font-medium block px-4 py-2  text-[14px] transition ease-in-out duration-150 flex justify-start text-center"
                        style={{ color: theme.Darkone }}
                        whileHover={{ backgroundColor: theme.hoverBackground }}
                      >
                        {isDarkMode ? (
                          <>
                            <span
                              style={{ backgroundColor: '#FFE7E8' }}
                              className="rounded-full h-6 w-6 inline-flex justify-center items-center mr-2"
                            >
                              <Icons.Sun className="h-4 w-4" style={{ color: '#FC5F66' }} />
                            </span>
                            Light Mode
                          </>
                        ) : (
                          <>
                            <span
                              style={{ backgroundColor: '#FFE7E8' }}
                              className="rounded-full h-6 w-6 inline-flex justify-center items-center mr-2"
                            >
                              <Icons.Moon className="h-4 w-4" style={{ color: '#FC5F66' }} />
                            </span>
                            Dark Mode
                          </>
                        )}
                      </motion.button>
                      <motion.button
                        className="w-full text-left font-medium block px-4 py-2  text-[14px] transition ease-in-out duration-150 flex justify-start text-center"
                        style={{ color: theme.Darkone }}
                        whileHover={{ backgroundColor: theme.hoverBackground }}
                        onClick={handleLogout}
                      >
                          <>
                            <span
                              style={{ backgroundColor: '#FFE7E8' }}
                              className="rounded-full h-6 w-6 inline-flex justify-center items-center mr-2"
                            >
                               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-log-out h-4 w-4"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/></svg> 
                            </span>
                            Logout
                          </>
                      </motion.button>
                    
                    </div>
                  </motion.div>
                )}
              </AnimatePresence> */}
              <AnimatePresence>
                {isDropdownVisible && (
                  <motion.div
                    ref={dropdownRef}
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.2 }}
                    className="absolute right-0 mt-2 w-[251px] rounded-[12px] shadow-lg ring-1 ring-black ring-opacity-5 z-50 "
                    style={{
                      backgroundColor: theme.background,
                      position: 'absolute',
                      top: '-23px',
                      borderRadius: '12px',
                    }}
                    onMouseLeave={toggleDropdown}
                  >
                    <div className="pt-2">
                      {/* Header Section */}
                      <div
                        className="px-[14px] pb-[14px]"
                        style={{
                          borderColor: theme.border,
                        }}
                      >
                        <p
                          className="text-[14px] font-medium flex items-center"
                          style={{
                            color: theme.color,
                          }}
                        >
                          <span
                            style={{
                              background: 'linear-gradient(360deg, #FB5F65 0%, #F377C5 130.91%)',
                              borderRadius: '50%',
                              display: 'inline-flex',
                              width: '40px',
                              minWidth: '40px',
                              height: '40px',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginRight: '10px',
                            }}
                          >
                            <span style={{ color: 'white', fontSize: '16px', fontWeight: 500 }}>  {userDetail && userDetail.ogUserId ? getFirstNonEmptyChar(userDetail.ogCompanyName) : getFirstNonEmptyChar(userDetail.name)}</span>
                          </span>

                          <div style={{display:'flex', flexDirection:'column'}}>
                            <span className='name cursor' style={{ wordBreak: 'break-all', textTransform: 'capitalize',fontSize:'16px', fontWeight:500}}> {userDetail && userDetail.ogUserId ? userDetail.ogCompanyName : userDetail.name}</span>
                            <span className='sub-n truncate-text-mail cursor' style={{ fontSize:'12px', fontWeight:400 }}> {userDetail && userDetail.ogUserId ? '' : userDetail.email}</span>
                          </div>
                        </p>

                      </div>


                      {/* Menu Items */}

                      {/* <motion.button
                        className="w-full on-hover text-left font-medium block px-4 py-2 text-[14px] transition ease-in-out duration-150 flex justify-start items-center"
                        style={{ color: theme.headerButtons, fontSize: '14px', fontWeight: '400', lineHeight: '16.94px' }}
                        whileHover={{ backgroundColor: theme.hoverBackground }}
                      >
                        <span
                          style={{ color: theme.headerButtons }}
                          className="rounded-full h-6 w-6 inline-flex justify-center items-center mr-2">

                          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_3437_2688)">
                              <path d="M4.24682 17.355L2.16382 7.77002L6.33082 9.85402L10.4968 4.02002L14.6638 9.85402L18.8308 7.77002L16.7468 17.354L4.24682 17.355Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                              <path d="M10.5029 14.439C10.7219 14.439 10.9386 14.3959 11.1409 14.3121C11.3431 14.2283 11.5269 14.1055 11.6817 13.9507C11.8365 13.7959 11.9593 13.6122 12.043 13.4099C12.1268 13.2077 12.1699 12.9909 12.1699 12.772C12.1699 12.5531 12.1268 12.3363 12.043 12.134C11.9593 11.9318 11.8365 11.748 11.6817 11.5932C11.5269 11.4384 11.3431 11.3156 11.1409 11.2319C10.9386 11.1481 10.7219 11.105 10.5029 11.105C10.0608 11.105 9.63681 11.2806 9.32419 11.5932C9.01157 11.9059 8.83594 12.3299 8.83594 12.772C8.83594 13.2141 9.01157 13.6381 9.32419 13.9507C9.63681 14.2634 10.0608 14.439 10.5029 14.439Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_3437_2688">
                                <rect width="21" height="21" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>

                        </span>
                        My Plan
                      </motion.button> */}

                      {/* Upgrade Plan Section */}
                      <div
                        className="flex justify-between configur_button items-center pl-[22px] px-4 pr-[0] py-3"
                        style={{
                          background: 'linear-gradient(90deg, #FAE1E2 0%, #FFD9F1 100%)',
                          width: '270px'
                        }}
                      >
                        <p
                          className="text-[14px] font-inter font-medium"
                          style={{
                            color: '#222222',
                            fontSize:'14px'
                          }}
                        >
                          Branding
                        </p>
                        <button
                          className="text-[12px] px-3 py-1 rounded-[8px]"
                          onClick={() => {
                            const planName = userDetail?.ogSubscriptionId?.planName;
                            if (planName === "free_y" || planName === "noPlan_m") {
                              setPlanPopupMessage("This feature is not included| in your current plan.");
                              setShowPlanPopup(true);
                            } else {
                              setIsBrandingOpen(!isBrandingOpen);
                            }
                          }}
                          style={{
                            backgroundImage: "linear-gradient(277.16deg, #FB5F65 -22.31%, #FF3AB6 112.77%)",
                            color: '#FFFFFF',
                            height: '29px',
                            marginRight: '31px',
                            fontSize:'12px',
                            fontWeight:500

                          }}
                        >
                          {userDetail && userDetail.brandDetails && userDetail.brandDetails.customBrand && userDetail.brandDetails.customBrand.logo && (userDetail.brandDetails.customBrand.primaryColor || userDetail.brandDetails.customBrand.secondaryColor || userDetail.brandDetails.customBrand.backgroundColor ) ?  'Configured' :'Configure Now' }
                        </button>
                      </div>
                      {/* <motion.button
                        className="w-full text-left font-medium block px-4 py-2 text-[14px] transition ease-in-out duration-150 flex justify-start items-center"
                        style={{ color: theme.headerButtons, fontSize: '14px', fontWeight: '400', lineHeight: '16.94px' }}
                        whileHover={{ backgroundColor: theme.hoverBackground }}
                      >
                        <span
                          style={{ color: theme.headerButtons }}
                          className="rounded-full h-6 w-6 inline-flex justify-center items-center mr-2">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 12.88V11.12C2 10.08 2.85 9.22 3.9 9.22C5.71 9.22 6.45 7.94 5.54 6.37C5.02 5.47 5.33 4.3 6.24 3.78L7.97 2.79C8.76 2.32 9.78 2.6 10.25 3.39L10.36 3.58C11.26 5.15 12.74 5.15 13.65 3.58L13.76 3.39C14.23 2.6 15.25 2.32 16.04 2.79L17.77 3.78C18.68 4.3 18.99 5.47 18.47 6.37C17.56 7.94 18.3 9.22 20.11 9.22C21.15 9.22 22.01 10.07 22.01 11.12V12.88C22.01 13.92 21.16 14.78 20.11 14.78C18.3 14.78 17.56 16.06 18.47 17.63C18.99 18.54 18.68 19.7 17.77 20.22L16.04 21.21C15.25 21.68 14.23 21.4 13.76 20.61L13.65 20.42C12.75 18.85 11.27 18.85 10.36 20.42L10.25 20.61C9.78 21.4 8.76 21.68 7.97 21.21L6.24 20.22C5.33 19.7 5.02 18.53 5.54 17.63C6.45 16.06 5.71 14.78 3.9 14.78C2.85 14.78 2 13.92 2 12.88Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>
                        Settings
                      </motion.button> */}

                      {/* <motion.button

                        className="w-full text-left font-medium block px-4 py-2 text-[14px] transition ease-in-out duration-150 flex justify-between items-center"
                        style={{
                          color: theme.headerButtons,
                          fontSize: '14px',
                          fontWeight: '400',
                          lineHeight: '16.94px',
                        }}
                        whileHover={{ backgroundColor: theme.hoverBackground }}
                      >
                        <div className="flex items-center">
                          <span
                            style={{
                              color: theme.headerButtons,
                              fontSize: '14px',
                              fontWeight: '400',
                              lineHeight: '16.94px',
                            }}
                            className="h-6 w-6 inline-flex justify-center items-center mr-2"
                          >
                            {isDarkMode ? (
                              <svg
                                width="21"
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.77621 10.8673C2.09121 15.3736 5.91496 19.0398 10.4912 19.2411C13.72 19.3811 16.6075 17.8761 18.34 15.5048C19.0575 14.5336 18.6725 13.8861 17.4737 14.1048C16.8875 14.2098 16.2837 14.2536 15.6537 14.2273C11.375 14.0523 7.87496 10.4736 7.85746 6.24734C7.84871 5.10984 8.08496 4.03359 8.51371 3.05359C8.98621 1.96859 8.41746 1.45234 7.32371 1.91609C3.85871 3.37734 1.48746 6.86859 1.77621 10.8673Z"
                                  stroke="currentColor"
                                  strokeWidth="1.3125"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            ) : (
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 15.5899 8.41015 18.5 12 18.5Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M19.14 19.14L19.01 19.01M19.01 4.99L19.14 4.86L19.01 4.99ZM4.86 19.14L4.99 19.01L4.86 19.14ZM12 2.08V2V2.08ZM12 22V21.92V22ZM2.08 12H2H2.08ZM22 12H21.92H22ZM4.99 4.99L4.86 4.86L4.99 4.99Z"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            )}
                          </span>
                          <span>{isDarkMode ? 'Dark Mode' : 'Light Mode'}</span>
                        </div>

                        <div
                          className={`toggle-container ${isToggled ? "active" : ""}`}
                          onClick={() => {
                            toggleSwitch();
                            toggleTheme();
                          }}
                        >
                          <div className="toggle-circle"></div>
                        </div>
                      </motion.button> */}

                      {/* <motion.button
                        className="w-full text-left font-medium block px-4 py-2 text-[14px] transition ease-in-out duration-150 flex justify-start items-center"
                        style={{ color: theme.headerButtons, fontSize: '14px', fontWeight: '400', lineHeight: '16.94px' }}
                        whileHover={{ backgroundColor: theme.hoverBackground }}
                      >
                        <span
                          style={{ color: theme.headerButtons }}
                          className="rounded-full h-6 w-6 inline-flex justify-center items-center mr-2"

                        >
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M22.0003 12.86C22.0003 15.15 20.8203 17.18 19.0003 18.46L17.6603 21.41C17.3503 22.08 16.4503 22.21 15.9803 21.64L14.5003 19.86C12.0803 19.86 9.92031 18.79 8.57031 17.12L9.50031 16C13.6403 16 17.0003 12.87 17.0003 9C17.0003 7.95 16.7503 6.96001 16.3003 6.07001C19.5703 6.82001 22.0003 9.57999 22.0003 12.86Z"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7 9H12"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>


                        </span>
                        Support
                      </motion.button> */}
                      { userDetail.ogUserId && (
                        <motion.button
                          className="w-full text-left font-medium block px-4 py-2 text-[14px] transition ease-in-out duration-150 flex justify-start items-center"
                          style={{ color: theme.headerButtons, fontSize:'14px', fontWeight:'400', lineHeight:'16.94px' }}
                          whileHover={{ backgroundColor: theme.hoverBackground }}
                          onClick={()=>navigate('/planinfo')}
                        >
                          <span
                            style={{color: theme.headerButtons}}
                            className="rounded-full h-6 w-6 inline-flex justify-center items-center mr-2"
                          >
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_3437_2688)">
                                <path d="M4.24682 17.355L2.16382 7.77002L6.33082 9.85402L10.4968 4.02002L14.6638 9.85402L18.8308 7.77002L16.7468 17.354L4.24682 17.355Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                                <path d="M10.5029 14.439C10.7219 14.439 10.9386 14.3959 11.1409 14.3121C11.3431 14.2283 11.5269 14.1055 11.6817 13.9507C11.8365 13.7959 11.9593 13.6122 12.043 13.4099C12.1268 13.2077 12.1699 12.9909 12.1699 12.772C12.1699 12.5531 12.1268 12.3363 12.043 12.134C11.9593 11.9318 11.8365 11.748 11.6817 11.5932C11.5269 11.4384 11.3431 11.3156 11.1409 11.2319C10.9386 11.1481 10.7219 11.105 10.5029 11.105C10.0608 11.105 9.63681 11.2806 9.32419 11.5932C9.01157 11.9059 8.83594 12.3299 8.83594 12.772C8.83594 13.2141 9.01157 13.6381 9.32419 13.9507C9.63681 14.2634 10.0608 14.439 10.5029 14.439Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_3437_2688">
                                  <rect width="21" height="21" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          Subscription
                        </motion.button>
                      )}

                      {userDetail && !userDetail.ogUserId &&
                        <motion.button
                          className="w-full on-hover text-left font-medium block px-[20px] py-[14px] text-[14px] transition ease-in-out duration-150 flex justify-start items-center"
                          style={{ color: theme.headerButtons, fontSize: '14px', fontWeight: '400', lineHeight: '16.94px' }}
                          whileHover={{ backgroundColor: theme.hoverBackground}}
                          onClick={()=>navigate('/accountSetting')}
                        >
                          <span style={{ color: theme.headerButtons }} className="rounded-full h-6 w-6 inline-flex justify-center items-center mr-2">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.12 12.78C12.05 12.77 11.96 12.77 11.88 12.78C10.12 12.72 8.71997 11.28 8.71997 9.51004C8.71997 7.70004 10.18 6.23004 12 6.23004C13.81 6.23004 15.28 7.70004 15.28 9.51004C15.27 11.28 13.88 12.72 12.12 12.78Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M18.74 19.3801C16.96 21.0101 14.6 22.0001 12 22.0001C9.40001 22.0001 7.04001 21.0101 5.26001 19.3801C5.36001 18.4401 5.96001 17.5201 7.03001 16.8001C9.77001 14.9801 14.25 14.9801 16.97 16.8001C18.04 17.5201 18.64 18.4401 18.74 19.3801Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M12 22C17.5228 22 22 17.5229 22 12C22 6.4772 17.5228 2.00005 12 2.00005C6.47715 2.00005 2 6.4772 2 12C2 17.5229 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </span>
                          My Profile
                        </motion.button>}

                     <motion.button
  className="w-full text-left font-medium block px-[20px] py-[14px] text-[14px] transition ease-in-out duration-150 flex justify-start items-center"
  style={{
    color: theme.headerButtons,
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '16.94px',
    backgroundColor: 'transparent',
    borderRadius: '0px', // normal state (no rounded corners)
  }}
  whileHover={{
    backgroundColor: theme.hoverBackground || '#f5f5f5',
    borderBottomLeftRadius: '10px',
    borderBottomRightRadius: '10px',
    transition: { duration: 0.2, ease: 'easeInOut' },
  }}
  onClick={handleLogout}
>
  <span
    className="rounded-full h-6 w-6 inline-flex justify-center items-center mr-2"
    style={{ color: theme.headerButtons }}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.41675 6.29995C7.67508 3.29995 9.21675 2.07495 12.5917 2.07495H12.7001C16.4251 2.07495 17.9167 3.56662 17.9167 7.29162V12.725C17.9167 16.45 16.4251 17.9416 12.7001 17.9416H12.5917C9.24175 17.9416 7.70008 16.7333 7.42508 13.7833"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4999 10H3.0166"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.87492 7.20825L2.08325 9.99992L4.87492 12.7916"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
  Logout
</motion.button>

                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

            </div>
          </div>
        </div>
      </motion.header>
      <AnimatePresence>
        {isBrandingOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            style={{ overflow: 'hidden' }}
            className="relative z-99"
          >
            <Branding onClose={() => setIsBrandingOpen(false)} />
          </motion.div>
        )}
      </AnimatePresence>
      {showPlanPopup && (
  <PlanPopup
    message={planPopupMessage}
    onClose={() => setShowPlanPopup(false)}
  />
)}
    </>
  );
}